const STRINGS = {
  // eslint-disable-next-line no-unused-vars
  collapseAll: rowsCount => `Collapse all collapsible rows`,
  // eslint-disable-next-line no-unused-vars
  collapseAllRowsAnnouncement: rowsCount => `All collapsible rows collapsed`,
  collapseSingle: "Collapse",
  footerLabel: "Table Footer",
  emptyDataMessage: {
    title: "No data available.",
    body: ""
  },
  rowExpandButtonLabel: function (itemKey) {
    let item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return `${item.expanded ? "collapse" : "expand"} more about ${itemKey}`;
  },
  // eslint-disable-next-line no-unused-vars
  expandAll: rowsCount => `Expand all expandable rows`,
  // eslint-disable-next-line no-unused-vars
  expandAllRowsAnnouncement: rowsCount => `All expandable rows expanded`,
  rowExpandedLabel: uniqueNumber => `${uniqueNumber}, expanded content`,
  collapsedRowAnnouncement: itemKey => `more about ${itemKey}, collapsed`,
  expandedRowAnnouncement: itemKey => `more about ${itemKey}, expanded`,
  rowExpandedDetails: itemKey => `${itemKey} details`,
  expandSingle: "Expand",
  row: "Row",
  sortAscending: "sorted ascending",
  sortDescending: "sorted descending",
  sortable: "sortable",
  sorted: "sorted",
  sortedBy: "sorted by",
  select: "Select",
  selectAll: "Select All",
  selectTypeRowInstructions: "Use SPACE to select a row.",
  selected: "selected",
  deselected: "unselected",
  getSelectAllStatus: (selectedRowsCount, status) => `${selectedRowsCount} rows ${status}`
};
export default STRINGS;